<template>
  <div class="service-page">
    <div v-if="service" class="bg-white shadow-sm pb-4">
      <ServiceInfo :service="service" :clinic-service-id="$route.query.service"></ServiceInfo>
      <template v-if="$route.query.service">
          <SchedulePatient
            :doctor="doctor"
            :service.sync="clinic_service"
            :date-index="$route.query.date"
            :time-index="$route.query.time"
          ></SchedulePatient>
        </template>
    </div>
    <LoadingMore v-if="loading"></LoadingMore>
  </div>
</template>
<script>
import ServiceInfo from '@/components/ServiceInfo.vue'
import SchedulePatient from '@/components/Schedule/Patient'
import LoadingMore from '@/components/Loadings/More'
import { mapGetters, mapMutations } from 'vuex'
export default {
  components: {
    LoadingMore,
    ServiceInfo,
    SchedulePatient
  },
  data () {
    return {
      loading: false,
      service_id: null
    }
  },
  computed: {
    ...mapGetters({
      authUser: 'auth/user',
      authLocale: 'auth/locale',
      serviceById: 'service/byId'
    }),
    service () {
      return this.serviceById(this.service_id)
    },
    doctor () {
      if (!this.service || !this.service.doctor_services) {
        return null
      }
      return this.service.doctor_services
    },
    clinic_service () {
      if (!this.$route.query.service) {
        return null
      }
      for (const cs of this.service.clinic_services) {
        if (cs.id === this.$route.query.service) {
          return cs
        }
      }
      return null
    }
  },
  mounted () {
    this.fetchSchedules(this.$route.params.id)
    this.fetch(this.$route.params.id)
    // this.setHead({ url: '/doctors', text: this.$t('Doctor') })
  },
  destroyed () {
    this.resetHead()
  },
  methods: {
    ...mapMutations({
      setAlert: 'alert/setAlert',
      setDoctor: 'doctor/set',
      setService: 'service/set',
      setSchedule: 'schedule/set',
      setChat: 'chat/set',
      setHead: 'head/set',
      resetHead: 'head/reset'
    }),
    async fetch (id) {
      if (this.serviceById(id)) {
        this.service_id = id
        return
      }
      this.loading = true
      try {
        const response = await this.axios.get(`/api/services/${id}`)
        const service = response.data.data
        console.log(service)
        this.setService({
          id: service.id,
          name: service.name,
          description: service.description,
          category_id: service.category_id,
          template: service.template,
          is_personal: service.is_personal,
          doctor_services: service.doctor_services,
          clinic_services: service.clinic_services
        })
        if (
          service.is_personal &&
            service.doctor_services &&
            service.doctor_services.length > 0
        ) {
          for (const ds of service.doctor_services) {
            this.setDoctor({
              id: ds.doctor.id,
              firstname: ds.doctor.firstname,
              lastname: ds.doctor.lastname,
              busy: service.busy,
              speciality_id: ds.doctor.speciality_id,
              title: ds.doctor.title,
              experience_from: ds.doctor.experience_from,
              chat: null,
              clinic_services: ds.clinic_services,
              photo: ds.doctor.photo,
              country: ds.doctor.country,
              gender: ds.doctor.gender,
              birthdate: ds.doctor.birthdate,
              language: ds.doctor.language,
              languages: ds.doctor.languages,
              email: ds.doctor.email_address,
              phone: ds.doctor.phone_number
            })
            this.$ga.ecommerce.addImpression({
              id: ds.doctor.id,
              name: `${ds.doctor.firstname.en} ${ds.doctor.lastname.en}`,
              category: 'Doctor',
              list: 'services',
              position: 0
            })
          }
        } else {
          this.$ga.ecommerce.addImpression({
            id: service.id,
            name: service.name.en,
            category: 'Service',
            list: 'services',
            position: 0
          })
        }
        this.service_id = service.id
        this.loading = false
      } catch (err) {
        this.setAlert({
          message: err,
          type: 'danger'
        })
        this.loading = false
      }
    },
    async fetchSchedules (id) {
      if (!this.authUser) {
        return
      }
      try {
        const params = {
          offset: 0,
          limit: 10,
          assignee_id: id,
          statuses: ['pending', 'payment_required', 'completed']
        }
        const response = await this.axios.get('/api/schedules/upcoming', {
          params
        })
        const schedules = response.data.data
        for (const schedule of schedules) {
          this.setSchedule({
            id: schedule.id,
            city_id: schedule.city_id,
            address: schedule.address,
            patient_id: schedule.patient_id,
            patient: schedule.patient,
            clinic_service_id: schedule.clinic_service_id,
            clinic_service: schedule.clinic_service,
            clinic_id: schedule.clinic_id,
            service_id: schedule.service_id,
            assignee_id: schedule.assignee_id,
            assignee: schedule.assignee,
            communication_days: schedule.communication_days,
            start_time: schedule.start_time,
            status: schedule.status,
            price: schedule.price,
            comment: schedule.comment,
            interview_id: schedule.interview_id,
            interview_status: schedule.interview_status,
            patient_case_id: schedule.patient_case_id,
            created_at: schedule.created_at,
            created_by: schedule.created_by
          })
        }
      } catch (err) {
        this.setAlert({
          message: err,
          type: 'danger'
        })
      }
    }
  }
}
</script>
<style lang="scss">
.service-page {
  background-color: #eee;
  height: 100%;
}
</style>
